import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextModule, ButtonModule } from 'primeng/primeng';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FilterComponent } from './filter.component';

@NgModule({
  imports: [
    CommonModule,
    InputTextModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule
  ],
  declarations: [FilterComponent],
  exports: [FilterComponent]
})
export class FilterModule { }



// WEBPACK FOOTER //
// /dist/src/app/shared/filter/filter.module.ts